import {
  CLIENT_CONTEXT_QUERY_PARAM,
  type ClientContextKeys,
} from '~/utils/context-setter-storage.ts';

/**
 * Generates a client feed URL by appending the feedUrl as a query parameter.
 *
 * @param feedUrl - The URL of the feed.
 * @param clientContextKeys - Optional Context Setter keys to send to `/api/client-feed`.
 * @returns The client feed URL with the feedUrl encoded as a query parameter.
 */
export function getClientFeedUrl(
  feedUrl: string,
  clientContextKeys?: ClientContextKeys
): string {
  const clientFeedSearchParams: URLSearchParams = new URLSearchParams();

  clientFeedSearchParams.set('feed-url', feedUrl);

  if (clientContextKeys && Object.keys(clientContextKeys).length > 0) {
    clientFeedSearchParams.set(
      CLIENT_CONTEXT_QUERY_PARAM,
      JSON.stringify(clientContextKeys)
    );
  }

  return `api/client-feed?${clientFeedSearchParams.toString()}`;
}
